import { app } from "/src/firebase.js";
import { getFirestore, collection, doc, getDoc, addDoc, setDoc, where, getDocs, query, getAggregateFromServer, sum, limit, orderBy, runTransaction } from "firebase/firestore";
import { mapValues, groupBy, omit, merge  } from "lodash";
import { peopleToOffer  } from "/src/peopleToOffer.js";
import dayjs from "dayjs";
import { getPodImage } from '/src/pods.js';

var config = { };


function getDB() {
  return getFirestore(app, import.meta.env.VITE_DB);
}

async function getConfig(db) {
  console.debug("🗄️ GETCONFIG");
  const docRef = doc(db, "config", "coffee");
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
      //console.debug("🗄️ Document data:", docSnap.data());
      config = docSnap.data();
  } else {
      // docSnap.data() will be undefined in this case
      console.debug("🗄️ No such document!");
  }
}

async function pay(db, user, num) {
    console.debug("🗄️ PAY");
    const coffeeRef = collection(db, "coffee");

    const currentDate = dayjs();
    const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

    await setDoc(doc(coffeeRef), {
        owner: user, quantity: num, created_at: formattedDate });
    
    //totCoffee(db, user);
    //listCoffee(db, user, 5);
    //stats(db, "2025-01-01");
    //getCredit(db, user);
  }

  async function totCoffeeX(db, user) {
    console.debug("🗄️ TOTCOFFEE");

    const today = dayjs().format('YYYY-MM-DD');
    const q = query(collection(db, "coffee"), where('owner', '==', user), where("created_at", ">=", today));

    const snapshot = await getAggregateFromServer(q, {
      totCoffee: sum('quantity')
    });

    var tot = snapshot.data().totCoffee;

    console.debug('totCoffee: ', tot);
    $("#drinkCoffeeTot").html(tot);
    $("#offeredCoffeeTot").html(tot);
    return tot;
  }

  async function totCoffee(db, user) {
    console.debug("🗄️ TOTCOFFEE");

    var totDrink = 0;
    var totOffer = 0;

    const today = dayjs().format('YYYY-MM-DD');
    const q = query(collection(db, "coffee"), where('owner', '==', user), where("created_at", ">=", today));

    const querySnapshot = await getDocs(q);

    var list = [];
    querySnapshot.forEach((doc) => {
        var cur = doc.data();
        if (cur.type == "drink") {
            totDrink++;
        } else if (cur.type == "offer"){
            totOffer++;
        }
    });

    console.debug('🗄️ totDrink: ', totDrink);
    console.debug('🗄️ totOffer: ', totOffer);
    $("#drinkCoffeeTot").html(totDrink);
    $("#offeredCoffeeTot").html(totOffer);

    return { "totDrink": totDrink, "totOffer": totOffer };
  }
  
  async function showCoffee(db, user) {
    console.debug("🗄️ SHOWCOFFEE");
    
    const today = dayjs().format('YYYY-MM-DD');
    const q = query(collection(db, "coffee"), where("owner", "==", user), where("created_at", ">=", today), orderBy("created_at", "desc"));
    const querySnapshot = await getDocs(q);

    var list = [];
    querySnapshot.forEach((doc) => {
        //console.debug("🗄️ Adding coffe " + doc.data());

        var cur = doc.data();
        cur.id = doc.id;
        list.push(cur);
    });

    //$("#coffee").html(buttons.write(list));
  }

  async function todayCoffee(db, user) {
    console.debug("🗄️ TODAYCOFFEE");
    
    const today = dayjs().format('YYYY-MM-DD');
    const q = query(collection(db, "coffee"), where("owner", "==", user), where("created_at", ">=", today), orderBy("created_at", "asc"));
    const querySnapshot = await getDocs(q);

    var list = [];
    querySnapshot.forEach((doc) => {
        //console.debug("🗄️ Adding coffe " + doc.data());

        var cur = doc.data();
        cur.id = doc.id;
        list.push(cur);
    });

    return list;
  }

/*
  async function showCoffeeOK(db, user) {
    console.debug("🗄️ SHOWCOFFEE");
    
    //var tot = await totCoffee(db, user);

    const today = dayjs().format('YYYY-MM-DD');
    const q = query(collection(db, "coffee"), where("owner", "==", user), where("created_at", ">=", today), orderBy("created_at", "desc"));
    const querySnapshot = await getDocs(q);
    
    var html = "";
    querySnapshot.forEach((doc) => {
        //console.debug(doc.data())
        html = html + "<button class=\"coffee-button\"><img data-id=\"" + doc.id + "\" src=\"/images/img/coffee-mug-icon.svg\"></img></button>";
    });

    //var html = "";
    //for (var i=0; i<tot; i++) {
    //    //html = html + "<td><button class=\"delete-coffee\" ><i data-id='" + doc.id + "' class='fa-solid fa-trash'></i></button></td>";
    //    html = html + "<button data-id=\"" + doc.id + "\"><img width=\"50px\" height=\"50px\" src=\"/src/images/img/coffee-mug-icon.svg\"></img></button>";
    //}

    $("#coffee").html(html);
  }
*/

  async function listCoffee(db, user, num) {
    console.debug("🗄️ LISTCOFFEE");
    const coffeeRef = collection(db, "coffee");


    const currentDate = dayjs();
    const formattedDate = currentDate.format('YYYY-MM-DD');

    const q = query(coffeeRef, where("owner", "==", user), orderBy("created_at", "desc"), limit(num));

    const querySnapshot = await getDocs(q);

    var html = "";
    html = html + "<table id='last-coffees' class='table table-striped table-bordered'>";
    html = html + "<thead>";
    html = html + "  <tr>";
    html = html + "    <th>Id</th>";
    html = html + "    <th>Data</th>";
    html = html + "    <th>Quantità</th>";
    html = html + "    <th>Autore</th>";
    html = html + "    <th>Action</th>";
    html = html + "  </tr>";
    html = html + "</thead>";
    html = html + "<tbody>"

    querySnapshot.forEach((doc) => {
      const cur = doc.data();
      html = html + "<tr>";
      html = html + "<td>" + doc.id + "</td>";
      html = html + "<td>" + cur.created_at + "</td>";
      html = html + "<td>" + cur.quantity + "</td>";
      html = html + "<td>" + cur.owner + "</td>";
      var coffeeDate = cur.created_at.substring(0, 10);
      //console.debug("🗄️ coffeeDate: " + coffeeDate + " - currentDate: " + formattedDate);
      if (coffeeDate == formattedDate) {
        html = html + "<td><button class=\"delete-coffee\" ><i data-id='" + doc.id + "' class='fa-solid fa-trash'></i></button></td>";
      } else {
        html = html + "<td></td>"; 
      }
      html = html + "</tr>";
    });

    html = html + "</tbody></table>";

    $("#coffee").html(html);
  }



  async function stats(db, date) {
    console.debug("🗄️ STATS");
    const coffeeRef = collection(db, "coffee");

    const q = query(coffeeRef, where("created_at", ">=", date), orderBy("created_at", "desc"));

    const querySnapshot = await getDocs(q);

    const rowData = [];
    querySnapshot.forEach(doc => rowData.push(doc.data()));
    var grouped = {};

    let listbyowner = groupBy(rowData, 'owner');
    for (const [key, value] of Object.entries(listbyowner)) {
      var info = groupBy(value, 'type');
      var offer = 0;
      var drink = 0;
      var mark = 0;
     if (info.offer) {
        offer = info.offer.reduce((n, {quantity}) => n + quantity, 0);
      }
      if (info.drink) {
        drink = info.drink.reduce((n, {quantity}) => n + quantity, 0);
      }
      if (info.mark) {
        mark = info.mark.reduce((n, {quantity}) => n + quantity, 0);
      }
      var cur = { user: key, drink: drink, offer: offer, mark: mark }
      grouped[key] = cur;
    }


    console.debug(grouped);

    return grouped;
  }

  async function getCredit(db) {
    console.debug("🗄️ GETCREDIT");
    
    var credits = [];
    const q1 = query(collection(db, "credit"), orderBy("created_at"));

    const querySnapshot1 = await getDocs(q1);

    querySnapshot1.forEach(cur => {
      console.debug('credit: ', cur.data()); 

      //deleteDoc(doc(db, "credit", cur.id));
      //omit(cur, 'created_at', 'owner', 'type'))
      credits.push( merge(cur.data(), { type: "credit"}) );
    });

    //await setDoc(doc(collection(db, "credit")), { owner: "samuel.talma@gmail.com", amount: 186.80, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "gianni.banfi@gmail.com", amount: 		-20.80, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "andrea.margnetti@gmail.com", amount: 	0.80, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "alessandro.voi@gmail.com", amount: 	-24, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "cristian.garcia.82@gmail.com", amount: 	-52.80, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "joulia.zin@gmail.com", amount: 		10.40 , created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "elia.genini@gmail.com", amount: 		-5.60, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "mettek88@gmail.com", amount: 		-32.80, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "dam.leonardi@gmail.com", amount: 		-12, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "theo.fumagalli@gmail.com", amount: 	5.60, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "bombellibarbara.92@gmail.com", amount: 	0.80, created_at: "2025-01-27 12:00:00" });
    //await setDoc(doc(collection(db, "credit")), { owner: "ilbonta@gmail.com", amount: 		-5.60, created_at: "2025-01-27 12:00:00" });
   
    return credits;
  }

  async function getExpenses(db) {
    console.debug("🗄️ GETEXPENSES");
    
    var expenses = [];
    const q1 = query(collection(db, "expenses"), orderBy("created_at"));

    const querySnapshot1 = await getDocs(q1);

    querySnapshot1.forEach(cur => {
      console.debug('expenses: ', cur.data()); 

      //deleteDoc(doc(db, "credit", cur.id));
      //omit(cur, 'created_at', 'owner', 'type'))
      expenses.push(merge(cur.data(), { type: "expense"}));
    });
   
    return expenses;
  }

  async function payCoffee(db, user, num, type) {
    console.debug("🗄️ PAYCOFFEE");

    const currentDate = dayjs();
    const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

    const currentUserRef = doc(db, "user", user);
    const currentCoffee = collection(db, "coffee");
    const currentCoffeeRef = await addDoc(currentCoffee, {owner: user, quantity: 0, created_at: formattedDate, type: type });
    
    return await runTransaction(db, async (transaction) => {
        await Promise.all([transaction.get(currentUserRef), transaction.get(currentCoffeeRef)]).then((docs) => { 
            let u = docs[0]; 
            let c = docs[1];

            if (!u.exists) {
                throw "Document does not exist!";
            }
            var oldBalance = u.data().balance;
            //var newBalance = Math.floor((oldBalance-(0.8*num)) * 100) / 100;
            var newBalance = ((oldBalance*10)-(8*parseInt(num)))/10;
            console.debug("🗄️ OLD: " + oldBalance + " - NEW: " + newBalance);

            var newUser = u.data();
            newUser.balance = newBalance;
            console.debug(newUser);

            var newCoffee = c.data();
            newCoffee.quantity = parseInt(num);
            console.debug(newCoffee);
            
            transaction.update(currentUserRef, newUser);
            transaction.update(currentCoffeeRef, newCoffee);
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
        updateBalance(db, user, "#credit", "#credit-coffee");
        totCoffee(db, user); 
        showCoffee(db, user);

        console.log("🗄️ currentCoffeeRef: %o", currentCoffeeRef);
        console.log("🗄️ New ID:", currentCoffeeRef.id);
        return currentCoffeeRef.id;
    }).catch((err) => {
        console.error(err);
        return null;
    });
  }



  async function createCoffee(db, user, type) {
    console.debug("🗄️ CREATECOFFEE");

    const currentDate = dayjs();
    const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss');


    const currentCoffee = collection(db, "coffee");
    const currentCoffeeRef = await addDoc(currentCoffee, {owner: user, quantity: 1, created_at: formattedDate, type: type });
    
    console.log("🗄️ currentCoffeeRef: %o", currentCoffeeRef);
    console.log("🗄️ New ID:", currentCoffeeRef.id);
    return currentCoffeeRef.id;
    
  }
   

  async function deleteCoffee(db, user, id) {
    console.debug("🗄️ DELETECOFFEE");

    const currentUserRef = doc(db, "user", user);
    const currentCoffeeRef = doc(db, "coffee", id);

    await runTransaction(db, async (transaction) => {
        await Promise.all([transaction.get(currentUserRef), transaction.get(currentCoffeeRef)]).then((docs) => { 
            let u = docs[0]; 
            let c = docs[1];

            if (!u.exists) {
                throw "Document does not exist!";
            }
            if (!c.exists) {
                throw "Document does not exist!";
            }

            var newUser = u.data();
            if (c.data().type === "drink" || c.data().type === "offer") {
              console.debug("🗄️ Updating balance for %o (%o)", u.data(), c.data());
              var oldBalance = u.data().balance;
              //var newBalance = Math.floor((oldBalance+(0.8*c.data().quantity)) * 100) / 100;
              var newBalance = ((oldBalance*10)+(8*parseInt(c.data().quantity)))/10;
              console.debug("🗄️ OLD: " + oldBalance + " - NEW: " + newBalance);

              
              newUser.balance = newBalance;
            } else {
              console.debug("🗄️ Skip updating balance for %o", c.data());
            }
            console.debug(newUser);

            transaction.update(currentUserRef, newUser);
            transaction.delete(currentCoffeeRef);

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
        updateBalance(db, user, "#credit", "#credit-coffee");
        totCoffee(db, user); 
        showCoffee(db, user);
    }).catch((err) => {
        console.error(err);
    });
  }

  async function getUser(db, user) {
    console.debug("🗄️ GETUSER " + user);
    var u;
    const userRef = doc(db, "user", user);
    const docSnap = await getDoc(userRef);

    if (docSnap.exists()) {
        //console.debug("🗄️ Document data:", docSnap.data());
        u = docSnap.data();
    } else {
        // docSnap.data() will be undefined in this case
        console.debug("🗄️ No such document!");
        u = null;
    }

    console.debug("🗄️ %o", u);
    //console.debug("🗄️ user = %s", JSON.stringify(u, null, 4));
    return u;
  }

  async function updateBalance(db, user, id, idHint) {
    console.debug("🗄️ UPDATEBALANCE");
    getUser(db, user).then((u) => {
        //$(id).html(u.balance + " CHF");
        $(id).html(Number(u.balance).toFixed(2) + " CHF");
        if (u.balance <0) {
          $(id).addClass('negative');
          $(idHint).html("(sei sotto di almeno " + (Math.round(u.balance/0.8)) + " caffè)");
          $(idHint).addClass('negative');
        } else {
          $(id).removeClass("negative");
          $(idHint).html("(equivalente a circa " + (Math.round(u.balance/0.8)) + " caffè)");
          $(idHint).removeClass("negative");
        }
        
    });
  }

  async function getDayStats(db, user, date) {
    console.debug("🗄️ STATS");
    const coffeeRef = collection(db, "coffee");

    var nextday = dayjs(date).add(1, "day").format('YYYY-MM-DD');
    console.debug("🗄️ day: " + date + " - next: " + nextday);
    const q = query(coffeeRef, where("owner", "==", user), where("created_at", ">=", date), where("created_at", "<", nextday));

    const querySnapshot = await getDocs(q);

    const rowData = [];
    querySnapshot.forEach(doc => rowData.push(doc.data()));
    let grouped = mapValues(groupBy(rowData, 'type'), 
      clist => clist.map(cur => omit(cur, 'created_at', 'owner', 'type'))
    );

    var stat = {};
    stat.label = dayjs(date).locale('it-ch').format('dd DD');
    stat.day = date;
    stat.created_at= dayjs().format('YYYY-MM-DD');

    if (grouped["drink"] != null)  {
        stat.drink = grouped["drink"].length;
    } else  {
        stat.drink = 0;   
    } 

    if (grouped["offer"] != null)  {
        stat.offer = grouped["offer"].length;
    } else  {
        stat.offer = 0; 
    } 

    if (grouped["mark"] != null)  {
        stat.mark = grouped["mark"].length;
    } else  {
        stat.mark = 0;   
    } 
    return new Promise(function(resolve, reject) {
        resolve(stat);
      });
   
  }

  async function saveAdmin(db, user, amount) {
    console.debug("🗄️ SAVEADMIN");

    const currentDate = dayjs();
    const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

    const currentUserRef = doc(db, "user", user);
    const currentCredit = collection(db, "credit");
    const currentCreditRef = await addDoc(currentCredit, {owner: user, amount: 0, created_at: formattedDate });
    const currentExpenses = collection(db, "expenses");
    const currentExpensesRef = await addDoc(currentExpenses, {owner: user, amount: 0, created_at: formattedDate, description: "" });
    
    await runTransaction(db, async (transaction) => {
        await Promise.all([transaction.get(currentUserRef), transaction.get(currentCreditRef), transaction.get(currentExpensesRef)]).then((docs) => { 
            let u = docs[0]; 
            let c = docs[1];
            let e = docs[2];

            if (!u.exists) {
                throw "Document does not exist!";
            }
            var oldBalance = u.data().balance;
            var newBalance = (Number(oldBalance) * 10 + Number(amount) * 10) / 10;
            console.debug("🗄️ OLD: " + oldBalance + " - NEW: " + newBalance);

            var newUser = u.data();
            newUser.balance = Number(newBalance);
            console.debug("🗄️ %o", newUser);

            var newCredit = c.data();
            newCredit.amount = Number(amount);
            console.debug("🗄️ %o", newCredit);

            var newExpenses = e.data();
            newExpenses.amount = Number(amount);
            newExpenses.description = "Credito acquistato da: " + u.data().alias;
            
            transaction.update(currentUserRef, newUser);
            transaction.update(currentCreditRef, newCredit);
            transaction.update(currentExpensesRef, newExpenses);

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

  async function saveExpenses(db, user, description, amount) {
    console.debug("🗄️ SAVEExpenses");

    const currentDate = dayjs();
    const formattedDate = currentDate.format('YYYY-MM-DD HH:mm:ss');

    const currentExpenses = collection(db, "expenses");
    const currentExpensesRef = await addDoc(currentExpenses, {owner: user, amount: 0, created_at: formattedDate, description: "" });
    
    await runTransaction(db, async (transaction) => {
      await transaction.get(currentExpensesRef).then((doc) => { 
            let e = doc;

            var newExpenses = e.data();
            newExpenses.amount = -Math.abs(Number(amount));
            newExpenses.description = description;

            transaction.update(currentExpensesRef, newExpenses);

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

  async function listUsers(db) {
    console.debug("🗄️ LISTUSER");
    const userRef = collection(db, "user");


    const q = query(userRef, orderBy("first_name", "desc"));

    const querySnapshot = await getDocs(q);

    var users = {};
    querySnapshot.forEach((doc) => {
        users[doc.id] =  doc.data();
    });

    return users;
  }

  async function changeColorPod(db, user, type, color) {

    const currentUserRef = doc(db, "user", user);

    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((doc) => { 
            let u = doc; 

            if (!u.exists) {
                throw "Document does not exist!";
            }

            var r = document.querySelector(':root');
            var newUser = u.data();
            if (type == 'drink') {
              newUser.color_drink = color;
              r.style.setProperty('--button-drink-img', "url(\"" + getPodImage(color) + "\")");
            } else if (type == 'offer') {
              newUser.color_offer = color;
              r.style.setProperty('--button-offer-img', "url(\"" + getPodImage(color) + "\")");
            } else if (type == 'mark') {
              newUser.color_mark = color;
              r.style.setProperty('--button-mark-img', "url(\"" + getPodImage(color) + "\")");
            }
            console.debug("🗄️ %o", newUser);

            transaction.update(currentUserRef, newUser);

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
        showCoffee(db, user);
    }).catch((err) => {
        console.error(err);
    });
  }

  async function saveAvatarImg(db, user, img) {
    const currentUserRef = doc(db, "user", user);

    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((doc) => { 
            let u = doc; 

            if (!u.exists) {
                throw "Document does not exist!";
            }

            var newUser = u.data();
            newUser.image = img;

            console.debug("🗄️ %o", newUser);

            transaction.update(currentUserRef, newUser);

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
        showCoffee(db, user);
    }).catch((err) => {
        console.error(err);
    });
  }

  async function deleteAvatarImg(db, user) {
    const currentUserRef = doc(db, "user", user);

    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((doc) => { 
            let u = doc; 

            if (!u.exists) {
                throw "Document does not exist!";
            }

            var newUser = u.data();
            newUser.image = "";

            console.debug("🗄️ %o", newUser);

            transaction.update(currentUserRef, newUser);

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
        showCoffee(db, user);
    }).catch((err) => {
        console.error(err);
    });
  }

  async function getAdminStats(db, user, date) {
    console.debug("🗄️ AGMINSTATS");
    const coffeeRef = collection(db, "coffee");

    var nextday = dayjs(date).add(1, "day").format('YYYY-MM-DD');
    console.debug("🗄️ day: " + date + " - next: " + nextday);
    const q = query(coffeeRef, where("created_at", ">=", date), where("created_at", "<", nextday));

    const querySnapshot = await getDocs(q);

    const rowData = [];
    querySnapshot.forEach(doc => rowData.push(doc.data()));
    let grouped = mapValues(groupBy(rowData, 'type'), 
      clist => clist.map(cur => omit(cur, 'created_at', 'owner', 'type'))
    );

    var stat = {};
    stat.label = dayjs(date).locale('it-ch').format('dd DD');
    stat.day = date;
    stat.created_at= dayjs().format('YYYY-MM-DD');

    if (grouped["drink"] != null)  {
        stat.drink = grouped["drink"].length;
    } else  {
        stat.drink = 0;   
    } 

    if (grouped["offer"] != null)  {
        stat.offer = grouped["offer"].length;
    } else  {
        stat.offer = 0; 
    } 

    if (grouped["mark"] != null)  {
        stat.mark = grouped["mark"].length;
    } else  {
        stat.mark = 0; 
    } 

    stat.tot = stat.drink + stat.offer + stat.mark;

    return new Promise(function(resolve, reject) {
        resolve(stat);
      });
   
  }

  async function saveWebPushSubscription(db, user, environment, sub, platform) {
    console.debug("🗄️ SAVEWEBPUSHSUBSCRIPTION");

    const currentUserRef = doc(db, "user", user);
    
    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((u) => { 
            
            if (!u.exists) {
                throw "Document does not exist!";
            }
            var subNotFound = true;
            var oldSub = null;
            if (u.data().push) {
              oldSub = u.data().push[environment];
            }
            var newSub = oldSub;
            
            if (oldSub) {
              for (var i=0; i<oldSub.length; i++) {
                console.debug("🗄️ OLD: " + oldSub[i].sub + " (" + oldSub[i].timestamp + ")");
                if (sub == oldSub[i].sub) {
                  newSub[i] = { "sub": sub, "timestamp": dayjs().format('YYYY-MM-DD HH:mm:ss'), "info": platform}
                  subNotFound = false;
                }
              }

              if (subNotFound) {
                newSub.push({ "sub": sub, "timestamp": dayjs().format('YYYY-MM-DD HH:mm:ss'), "info": platform});
              }
            } else {
              newSub = [{ "sub": sub, "timestamp": dayjs().format('YYYY-MM-DD HH:mm:ss'), "info": platform}];
            }

            for (var i=0; i<newSub.length; i++) {
              console.debug("🗄️ NEW: " + newSub[i].sub + " (" + newSub[i].timestamp + ") >> " + newSub[i].info );
            }

            var newUser = u.data();
            if (!newUser.push) {
              newUser.push = {};
            }
            if (!newUser.push[environment]) {
              newUser.push[environment] = [];
            }
            newUser.push[environment] = newSub;
            console.debug("🗄️ %o", newUser);

            transaction.update(currentUserRef, newUser);
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

  async function getWebPushSubscriptions(db, user, environment) {
    console.debug("🗄️ GETWEBPUSHSUBSCRIPTIONS");
    var subscriptions = [];
    const currentUserRef = doc(db, "user", user);
    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((u) => { 
            
            if (!u.exists) {
                throw "User does not exist!";
            }
            var curSub = u.data().push[environment];
            if (curSub) {
              for (var i=0; i<curSub.length; i++) {
                var sub = curSub[i].sub;
                var json = JSON.parse(sub);
                console.debug("🗄️ %o", json);

                subscriptions.push(json.keys.p256dh);
              }
            } else {
              console.debug("🗄️ no subscriptions found");
            }
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });

    return new Promise(function(resolve, reject) {
        resolve(subscriptions);
    });
  }

  async function deleteWebPushSubscription(db, user, environment, sub) {
    console.debug("🗄️ DELETEWEBPUSHSUBSCRIPTION");

    const currentUserRef = doc(db, "user", user);
    
    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((u) => { 
            
            if (!u.exists) {
                throw "Document does not exist!";
            }
            var oldSub = null;
            if (u.data().push) {
              oldSub = u.data().push[environment];
            }
            var newSub = [];
            
            if (oldSub) {
              for (var i=0; i<oldSub.length; i++) {
                console.debug("🗄️ ORIG: " + oldSub[i].sub + " (" + oldSub[i].timestamp + ") >> " + oldSub[i].info);
                var s = oldSub[i].sub;
                //console.log(s);
                var json = JSON.parse(s);
                if (sub == json.keys.p256dh) {
                  console.log("🗄️ Subscription found. removing it from valid subscriptions");
                } else {
                  newSub.push(oldSub[i]);
                }
              }
            } 

            for (var i=0; i<newSub.length; i++) {
              console.debug("🗄️ NEW: " + newSub[i].sub + " (" + newSub[i].timestamp + ") >> " + oldSub[i].info);
            }

            var newUser = u.data();
            if (!newUser.push) {
              newUser.push = {};
            }
            if (!newUser.push[environment]) {
              newUser.push[environment] = [];
            }
            newUser.push[environment] = newSub;

            console.debug(newUser);

            transaction.update(currentUserRef, newUser);
        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
    }).catch((err) => {
        console.error(err);
    });
  }

  async function showPeopleToOffer(db, user) {
    const currentUserRef = doc(db, "user", user);
    var currentAlias;

    await runTransaction(db, async (transaction) => {
        await transaction.get(currentUserRef).then((doc) => { 
        if (!doc.exists) {
            throw "Document does not exist!";
        }
        currentAlias = doc.data().alias;

        }).catch((err) => {
            console.error(err);
        });
    }).then(() => {
        console.debug("🗄️ Transaction OK");
        showCoffee(db, user);
    }).catch((err) => {
        console.error(err);
    });

    console.log("🗄️ -------------------> " + currentAlias);
    const q = query(collection(db, "member"), where('alias', '!=', currentAlias), orderBy("alias", "asc"));
    const querySnapshot = await getDocs(q);

    var list = [];
    querySnapshot.forEach((doc) => {
        var cur = doc.data();
        cur.id = doc.id;
        list.push(cur);
    });
    $("#peopleToOffer").html(peopleToOffer.write(list));
  }

export {getDB, getConfig, pay, payCoffee, createCoffee, getUser, updateBalance, stats, getCredit, getExpenses, totCoffee, deleteCoffee, listCoffee, showCoffee, todayCoffee, getDayStats, getAdminStats, saveAdmin, listUsers, saveExpenses, changeColorPod, saveAvatarImg, deleteAvatarImg, saveWebPushSubscription, getWebPushSubscriptions, deleteWebPushSubscription, showPeopleToOffer };